import styled from 'styled-components';
import {device} from '@guestapp/ui/src/utils/device';

type BanerProps = {
  $bigBgImage: string;
  $bgImage: string;
};

export const BannerLink = styled.a`
  width: 100%;
`;

export const Banner = styled.div<BanerProps>`
  width: 100%;
  padding: 89px 16px 10px;
  border-radius: 12px;
  background: left 0 bottom -36px no-repeat linear-gradient(180deg, rgba(255, 255, 255, 0)
          0%, rgba(255, 255, 255, 0.9) 65%),
    left top / cover no-repeat url(${props => props.$bgImage});
  color: black;

  @media (min-width: ${device.laptop}) {
    display: grid;
    padding: 20px 50px 22px;
    grid-template-columns: 1fr 1fr;
    background: right center no-repeat
        linear-gradient(90deg, rgba(255, 255, 255, 0) 32.49%, #ffffff 100%),
      left 25% / cover no-repeat url(${props => props.$bigBgImage});
  }
`;

export const Content = styled.div`
  grid-column-start: 2;
  max-width: 295px;
  @media (min-width: ${device.laptop}) {
    max-width: 495px;
  }
`;

export const Title = styled.h2`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0;
  margin-bottom: 2px;

  font-size: 16px;
  font-weight: 600;
  line-height: 20px;

  & .logo {
    margin-left: 8px;
    width: 104px;
    height: 19px;
  }

  @media (min-width: ${device.laptop}) {
    font-size: 24px;
    line-height: 36px;

    & .logo {
      width: 182px;
      height: 36px;
    }
  }
`;

export const Subtitle = styled.h3`
  margin: 0;
  margin-bottom: 2px;

  font-size: 12px;
  font-weight: 500;
  line-height: 18px;

  @media (min-width: ${device.laptop}) {
    font-size: 20px;
    font-weight: 400;
    line-height: 30px;
  }
`;

export const Price = styled.h3`
  margin: 0;

  font-size: 14px;
  font-weight: 600;
  line-height: 21px;

  @media (min-width: ${device.laptop}) {
    font-size: 24px;
    line-height: 36px;
  }
`;
